<template>
  <div class="flex items-center h-full w-full relative">
    <span class="text-sm leading-normal">{{ displayValue }}</span>
    <div v-if="hasApiData" class="absolute top-0.5 right-0.5 text-primary/70 hover:text-primary text-xs pointer-events-none">
      🛈
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  params: any
}

const props = defineProps<Props>()

// Add error handling for params access
const safeParams = computed(() => props.params || {})

const displayValue = computed(() => {
  try {
    const value = safeParams.value.value
    if (value === null || value === undefined) return ''
    
    if (typeof value === 'object' && value !== null) {
      return value.label || value.value || value.displayValue || ''
    }
    
    return String(value || '')
  } catch (error) {
    console.warn('DefaultCell displayValue error:', error)
    return ''
  }
})

const hasApiData = computed(() => {
  try {
    const value = safeParams.value.value
    return typeof value === 'object' && value !== null && 
      (value.sourceName || value.groundingMetadata || value.sourceText)
  } catch (error) {
    console.warn('DefaultCell hasApiData error:', error)
    return false
  }
})
</script> 